type Props = {
    label: string;
    children: React.ReactNode | React.ReactNode[]
}

export const GridRow = ({label, children}: Props) => (
    <div className='tw-flex tw-gap-2 tw-my-1'>
        <div className='tw-text-default-dimmed tw-w-1/3 tw-min-w-24 tw-flex-shrink-0'>{label}</div>
        <div className='tw-min-w-32'>{children}</div>
    </div>
);